import React, {
    Component,
    Suspense,
} from 'react'
import {
    Route,
    Switch,
} from 'react-router-dom'
import NotFoundRoute from './shared/not-found-route'
import { withRouter } from '../validator'
import AppContainer from '../app/app-container'
import AppIndex from '../app'
import { LoggedRoute } from './shared/logged-route'
import Login from '../app/auth/login'
import ForgottenPassword from '../app/auth/forgotten-password'
import Register from '../app/auth/register'
import { logout } from '../components/shared/auth/logout'
import UserForm from '../app/users/forms/user-form'
import i18n from '../locales/i18n'
import FoodForm from '../app/food-form'
import FoodFormDate from '../app/food-form-date'
import Fridge from '../app/home-display/fridge'
import RecipeForm from '../app/recipes/recipe-form'
import RecipeDetail from '../app/recipes/recipe-detail'
import Recipes from '../app/recipes/recipes'

@withRouter()
export default class GlobalRoutes extends Component {

    /**
     * Render
     *
     * @return {*}
     */
    render = () => (
        <Suspense fallback={<span />}>
            <Switch>
                <Route exact path="/" render={() => <AppContainer><AppIndex {...this.props} /></AppContainer>} />
                <Route exact path="/fridge" render={() => <AppContainer><Fridge {...this.props} /></AppContainer>} />
                <LoggedRoute exact path="/add" render={() => <AppContainer><FoodForm {...this.props} /></AppContainer>} />
                <LoggedRoute exact path="/add/:fridge" render={() => <AppContainer><FoodFormDate {...this.props} /></AppContainer>} />
                <LoggedRoute exact path="/recipes" render={() => <AppContainer><Recipes {...this.props} /></AppContainer>} />
                <LoggedRoute exact path="/recipes/add" render={() => <AppContainer><RecipeForm {...this.props} /></AppContainer>} />
                <LoggedRoute exact path="/recipes/:recipeUid" render={() => <AppContainer><RecipeDetail {...this.props} /></AppContainer>} />
                <LoggedRoute exact path="/recipes/:recipeUid/edit" render={() => <AppContainer><RecipeForm {...this.props} /></AppContainer>} />
                <Route exact path="/login" render={() => <AppContainer><Login {...this.props} /></AppContainer>} />
                <Route exact path="/login/forgotten-password" render={() => <AppContainer><ForgottenPassword {...this.props} /></AppContainer>} />

                <Route exact path="/register" render={() => <AppContainer><Register {...this.props} /></AppContainer>} />
                <LoggedRoute exact path="/admin" render={() => (
                    <AppContainer>
                        <div>Sekce po přihlášení</div>
                        <div onClick={logout}>{i18n.t('users.logout')}</div>
                        <div className="mt-3">
                            <UserForm />
                        </div>
                    </AppContainer>
                )} />

                <NotFoundRoute routesType="globalRoutes" />
            </Switch>
        </Suspense>
    )
}
